// state公共参数
export function hvuex ({state, commit}, status) {
  commit('hvuex', status)
}


// WEBPACK FOOTER //
// ./src/store/actions/widgetUi.js